import React from 'react';
import MultiSelectFilter from './MultiSelectFilter';
import type { AccuracyReportListFilterState } from '../services/accuracyReportListFilter';
import {
  buildGuidelineFilterOptions,
  buildJobFilterOptions,
  buildUrlStatusFilterOptions,
  hasActiveReportListFilters,
} from '../services/accuracyReportListFilter';
import type { SavedAccuracyReport } from '../types/accuracy';
import type { AccuracyScopeMetadata } from '../services/accuracyScopeMetadata';

interface AccuracyReportListFiltersProps {
  reports: SavedAccuracyReport[];
  filter: AccuracyReportListFilterState;
  onChange: (next: AccuracyReportListFilterState) => void;
  resultCount: number;
  totalCount: number;
  metadata?: AccuracyScopeMetadata | null;
}

export function AccuracyReportListFilters({
  reports,
  filter,
  onChange,
  resultCount,
  totalCount,
  metadata,
}: AccuracyReportListFiltersProps) {
  const guidelineOptions = buildGuidelineFilterOptions(reports, metadata);
  const jobOptions = buildJobFilterOptions(metadata);
  const urlStatusOptions = buildUrlStatusFilterOptions(reports);
  const active = hasActiveReportListFilters(filter);

  const patch = (partial: Partial<AccuracyReportListFilterState>) => {
    onChange({ ...filter, ...partial });
  };

  return (
    <div className="accuracy-report-list-filters">
      <div className="accuracy-report-list-filters-row">
        <MultiSelectFilter
          label="ガイドライン"
          options={guidelineOptions}
          selectedValues={filter.guidelineKeys}
          onSelectionChange={(guidelineKeys) => patch({ guidelineKeys })}
          placeholder="すべて"
          searchPlaceholder="ガイドライン名・バージョンで検索…"
        />
        <MultiSelectFilter
          label="ジョブ"
          options={jobOptions}
          selectedValues={filter.jobIds}
          onSelectionChange={(jobIds) => patch({ jobIds })}
          placeholder="すべて"
        />
        <MultiSelectFilter
          label="URLステータス"
          options={urlStatusOptions}
          selectedValues={filter.urlStatuses}
          onSelectionChange={(urlStatuses) =>
            patch({ urlStatuses: urlStatuses as AccuracyReportListFilterState['urlStatuses'] })
          }
          placeholder="すべて"
        />
        <label className="accuracy-report-list-date-filter">
          <span className="accuracy-report-list-date-label">作成日（から）</span>
          <input
            type="date"
            className="accuracy-report-list-date-input"
            value={filter.createdFrom}
            onChange={(e) => patch({ createdFrom: e.target.value })}
          />
        </label>
        <label className="accuracy-report-list-date-filter">
          <span className="accuracy-report-list-date-label">作成日（まで）</span>
          <input
            type="date"
            className="accuracy-report-list-date-input"
            value={filter.createdTo}
            min={filter.createdFrom || undefined}
            onChange={(e) => patch({ createdTo: e.target.value })}
          />
        </label>
      </div>
      <div className="accuracy-report-list-filters-footer">
        <span className="accuracy-report-list-filter-count">
          {resultCount} / {totalCount} 件
        </span>
        {active && (
          <button
            type="button"
            className="accuracy-button accuracy-report-list-filter-clear"
            onClick={() =>
              onChange({
                guidelineKeys: [],
                jobIds: [],
                urlStatuses: [],
                createdFrom: '',
                createdTo: '',
              })
            }
          >
            条件をクリア
          </button>
        )}
      </div>
    </div>
  );
}
